import { render } from "./EditAttachmentModal.vue?vue&type=template&id=156e01ac&scoped=true"
import script from "./EditAttachmentModal.vue?vue&type=script&lang=js"
export * from "./EditAttachmentModal.vue?vue&type=script&lang=js"

import "./EditAttachmentModal.vue?vue&type=style&index=0&id=156e01ac&scoped=true&lang=scss"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156e01ac"]])

export default __exports__